export { SocialLoginModule } from './auth.module';
export { AuthService, AuthServiceConfig } from './auth.service';
export { LoginProvider, SocialUser, LoginProviderClass, LinkedInResponse } from './entities/index';
export { FacebookLoginProvider, GoogleLoginProvider, LinkedinLoginProvider } from './providers/index';
